import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Import the components for the routes
import { ProductPageComponent } from './pages/product-page/product-page.component';
import { ProductDetailPageComponent } from './pages/product-detail-page/product-detail-page.component';
import { CartPageComponent } from './pages/cart-page/cart-page.component';
import { ChekoutPageComponent } from './pages/chekout-page/chekout-page.component';

const routes: Routes = [
  { path: '', redirectTo: '/products', pathMatch: 'full' }, // Redirect root to /products
  { path: 'products', component: ProductPageComponent }, // Product listing page
  { path: 'products/:id', component: ProductDetailPageComponent }, // Product detail page
  { path: 'cart', component: CartPageComponent }, // Cart page
  { path: 'checkout', component: ChekoutPageComponent }, // Cart page
  { path: '**', redirectTo: '/products' }, // Wildcard route redirects to /products
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })], // Configure the routes
  exports: [RouterModule], // Export the RouterModule for use in the app
})
export class AppRoutingModule {}
